export const addtocart = (data) => {
 return {type:"ADD_TO_CART",
  payload:data}
}

export const RemoveFromCart = (id) => {
 return {
    type:"REMOVE_FROM_CART",
    payload:id
 } 
}

export const Checkout =() => {
  return {
    type:"CHECKOUT"
  }
}